import { UI } from '../../static/js/helpers/UI.js'
import BackendAPI from '../../static/js/helpers/API.js'
import CartItem from './cart-item.js';
import { getCookie, setCookie } from '../../static/js/helpers/utils.js';
export default class UserCart extends HTMLElement {
  constructor() {
    super();
    this.API = new BackendAPI();
    this.API.setBaseUrl(host + '/cart');
    this._total = 0;
    this._discount = 0;
    this._formattedDiscount = 0;
    this._itemCount = 0;
    this._offerText = '';
  }

  get total() {
    return this._total;
  }
  set total(val) {
    this._total = val;
    this.updateCartTotal();
  }
  get discount() {
    return this._discount;
  }
  set discount(val) {
    this._discount = val;
  }
  get formattedDiscount() {
    return this._formattedDiscount;
  }
  set formattedDiscount(val) {
    this._formattedDiscount = val;
    this.updateCartDiscount();
  }
  get itemCount() {
    return this._itemCount;
  }
  set itemCount(val) {
    this._itemCount = val;
    this.updateCartStatus();
  }
  get offerText() {
    return this._offerText;
  }
  set offerText(val) {
    this._offerText = val;
  }
  // Updates the cart total
  updateCartTotal() {
    const subtotal = this.querySelector('.subtotal');
    subtotal.innerHTML = this.total;
  }
  // Updates the cart total
  updateCartDiscount() {
    const savings  = this.querySelector('.savings-total');
    if (this.discount == undefined || this.discount <= 0 || this.discount == null )
    {
      savings.closest('.savings-string').style.display = 'none';
    }
    else{
      savings.closest('.savings-string').style.display = 'block';
      savings.innerHTML = this.formattedDiscount;
    }
  }

  // Updates the cart status by showing or hiding the cart 
  updateCartStatus() {
    const cartItemCount = this.querySelector('.user .count');
    cartItemCount.innerHTML = this.itemCount > 0 ? this.itemCount : '';
    let cartLink = this.querySelector("a.cart");
    if (this.itemCount > 0) {
      cartLink.style.visibility = 'visible';
    }
    else {
      cartLink.style.visibility = 'hidden';
      this.hideCartMenu();
    }

    let userCart = this;
    let checkoutBtn = this.querySelector("#checkoutBtn")
    checkoutBtn.addEventListener('click', function (event) {
      event.preventDefault();
      if (userCart.itemCount > 0) {
        window.location.href = userCart.checkoutUrl;
      }
    }, false);
  }

  connectedCallback() {
    // Invoked each time the custom element is appended into DOM.
    (async () => {
      await this.renderTemplate(); // Wait for renderTemplate to complete
      this.cartMenu = this.querySelector("#cartMenu");
      this.setCartMenuHeight();
      this.selectedProductCard = null;
      var userCart = this;
      this.querySelector('a.cart').addEventListener('click', (event => {
        event.preventDefault();
        userCart.toggleCartMenu();
      }));
  
      document.addEventListener('click', function (event) {
        var isCartMenu = event.target.closest('#cartMenu');
        var isCartLink = event.target.closest('a.cart');
        var outOfSight = userCart.classList.contains("out-of-sight");
        if (!isCartMenu && !isCartLink && !outOfSight) {
          userCart.resetCartMenu();
        }
      });
  
      this.loadCartItems();
  
      // Registers event listeners for cart delete hover/click action
      const clearCartIcon = this.querySelector('#clearcart');
      if(clearCartIcon){
        clearCartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          this.clear();
        });
      }
  
      this.addEventListener('cartUpdated', (event) =>{
        let offerText = event.detail.offerText;
        this.offerText = offerText;
      });
    })();
  }
  
  toggleClearCartButton(){
    // Show hide clear cart button on clicking the count
    const cartCount = this.querySelector('#cartCount');
    const clearCartIcon = this.querySelector('#clearcart');
    if(cartCount){
      cartCount.addEventListener('click', (event) => {
        event.preventDefault();
        if (clearCartIcon.classList.contains("out-of-sight")) {
          this.showClearCart();
        } else {
          this.hideClearCart();
        }
      });
    }
  }
  
  showClearCart(){
    const clearCartIcon = this.querySelector('#clearcart');
    clearCartIcon.classList.remove('out-of-sight');
  }
  
  hideClearCart(){
    const clearCartIcon = this.querySelector('#clearcart');
    clearCartIcon.classList.add('out-of-sight');
  }

  registerClearCartIconListeners(){
    // Registers event listeners for cart delete hover/click action
    const clearCartIcon = this.querySelector('#clearcart');
    if(clearCartIcon){
      clearCartIcon.addEventListener('click', (event) => {
        event.preventDefault();
        this.clear();
      });
    }
    
  }

  registerAddAddonsToCardListners() {
    const addButtons = document.querySelectorAll('.add-button-wrapper .button');
    let userCart = this;
    const handleClick = function(event) {
      const button = event.target;
      const sku = button.getAttribute('data-sku'); // Access the data-sku attribute
      // Assuming userCart.addToCart takes quantity and SKU as parameters
      userCart.addToCart(1, sku); // Use the SKU from the data attribute

      userCart.cartAddingAnim()
      button.innerHTML = '&#10003;';
      setTimeout(() => {
        button.innerHTML = 'Add';
      }, 400);
      userCart.loadCartItems();
    };
    
  
    addButtons.forEach(function(button) {
      button.addEventListener('click', handleClick);
    });

  }
  getSizeFromCookies(type, style){
    let productData = getCookie('product_data');
    let size = null;
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              size = product[type][style]
            } 
        }
      } 
    }
    return size;
  }

  saveSizeData(size, type, style){
    let productData = getCookie('product_data');
    if (productData){
      let productDataList= JSON.parse(productData);
      if (productDataList && productDataList.length > 0){
          let product = productDataList.find(function(p){
              if (p.hasOwnProperty(type)){
                 return p;
              }
          });
          if (product){
            if (product[type].hasOwnProperty(style)){
              product[type][style] = size;
              setCookie('product_data', JSON.stringify(productDataList), 10*365);
            } 
        }
      } 
    }else{
      productData = [];
      let product = {[type]:{[style]:size}}
      productData.push(product)
      setCookie('product_data', JSON.stringify(productData), 10*365);
    }
  }

  setCartAddonsDefaultSwatchesSize() {
    const selectBoxes = document.querySelectorAll('.swatches');
    if (selectBoxes && selectBoxes.length > 0) {
      selectBoxes.forEach(selectBox => {
        if(selectBox.selectedIndex || selectBox.selectedIndex !== undefined){
          const selectedOption = selectBox.options[selectBox.selectedIndex];
          const productType = selectedOption.getAttribute('data-swatch-type');
          const productStyle = selectedOption.getAttribute('data-swatch-style');
          if(productType=='socks'){
            console.log("sett up socks default size")
          }
          if (productType && productType !== undefined) {
            let preferredSize = this.getSizeFromCookies(productType, productStyle)
            {
              for (let i = 0; i < selectBox.options.length; i++) {
                const option = selectBox.options[i];
                if (option.getAttribute("data-swatch-size") === preferredSize) {
                  selectBox.selectedIndex = i;
                  const event = new Event('change', { bubbles: true });
                  selectBox.dispatchEvent(event);
                  break;
                }
              }
            }
          }
        }
      });
    }
  }
  handleCartAddonSwatches() {
    var _this = this;
    const selectBoxes = document.querySelectorAll('.swatches');
    if (selectBoxes && selectBoxes != null && selectBoxes != undefined && selectBoxes.length > 0) {
      selectBoxes.forEach(selectBox => {
        selectBox.addEventListener('change', function () {
          const selectedOption = this.options[this.selectedIndex];
          const selectedPrice = selectedOption.getAttribute('data-swatch-price');
          const selectedOriginalPrice = selectedOption.getAttribute('data-swatch-original-price');
          const showStrikethrough = selectedOption.getAttribute('data-show-strikethrough');
          const priceElements = document.getElementsByClassName(selectedOption.getAttribute('data-price-class'));
          const originalPriceElements = document.getElementsByClassName(selectedOption.getAttribute('data-original-price-class'));
          const addBtns = document.getElementsByClassName(selectedOption.getAttribute('data-add-btn-class'));
          const selectAppearances = document.getElementsByClassName(selectedOption.getAttribute('data-select-appearance-class'));
          const productType = selectedOption.getAttribute('data-swatch-type');
          const productStyle = selectedOption.getAttribute('data-swatch-style');
          const productSize = selectedOption.getAttribute('data-swatch-size');
          _this.saveSizeData(productSize, productType, productStyle);

          if (priceElements && priceElements != null && priceElements != undefined) {
            Array.from(priceElements).forEach(priceElement => {
              priceElement.innerHTML = selectedPrice;
            });
          }
          if (originalPriceElements && originalPriceElements != null && originalPriceElements != undefined) {
            Array.from(originalPriceElements).forEach(originalPriceElement => {
              originalPriceElement.innerHTML = selectedOriginalPrice;

              if (showStrikethrough && showStrikethrough != null && showStrikethrough != undefined && showStrikethrough !== "True") {
                originalPriceElement.style.display = 'none';
              }
              else{
                originalPriceElement.style.display = 'block';
              }
            });
          }
          if (selectAppearances && selectAppearances != null && selectAppearances != undefined) {
            Array.from(selectAppearances).forEach(selectAppearance => {
              selectAppearance.innerHTML = selectedOption.innerHTML;
            })
          }
          if (addBtns && addBtns != null && addBtns != undefined) {
            Array.from(addBtns).forEach(addBtn => {
              addBtn.setAttribute('data-sku', selectedOption.value);
            })
          }

          selectBoxes.forEach(box => {
            if (box.options && box.options != null && box.options != undefined) {
              Array.from(box.options).forEach(option => {
                if (option.value === selectedOption.value) {
                  option.setAttribute('selected', true);
                }
              })
            }
          })
        });
      });
    }
  }


  disconnectedCallback() {
    // Invoked each time the custom element is disconnected from the document's DOM.
  }

  async renderTemplate() {
    const cartTemplate = document.createElement('template');
    cartTemplate.setAttribute('id', "user-cart");
    cartTemplate.innerHTML = `
      <a href="#" class="block-icon cart">
        <div class="dot"></div>
      </a>
      <div class="dropdown-menu fixed-block out-of-sight" id="cartMenu">
      </div>
`
    this.appendChild(cartTemplate.content.cloneNode(true));
    try {
      const addonUrl =  host + '/cart/addon_cart';
      const response = await fetch(addonUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const htmlContent = await response.text();
      const addonsWindow = this.querySelector("#cartMenu");
      if (addonsWindow) {
        addonsWindow.innerHTML = htmlContent;
      }
      this.registerClearCartIconListeners()
      this.registerAddAddonsToCardListners()
      this.handleCartAddonSwatches()
      this.setCartAddonsDefaultSwatchesSize()
      this.toggleClearCartButton()
    } catch (error) {
      console.error('Failed to fetch HTML content.', error);
    }
  }


  // Cart Animation
  cartAddingAnim() {
    let count = this.itemCount;
    document.querySelector("a.cart").classList.remove('bump');
    document.querySelector("a.cart").classList.add(`${count == 0 ? 'adding-first' : 'adding'}`);
    setTimeout(function () {
      document.querySelector("a.cart").classList.remove(`${count == 0 ? 'adding-first' : 'adding'}`);
      document.querySelector("a.cart").classList.add('bump');
    }, 200);
    setTimeout(function () {
      document.querySelector("a.cart").classList.remove('bump');
    }, 800);
  }

  showCartMenu() {
    UI.hideModals();
    document.querySelector('body').style.overflow = 'hidden';
    document.querySelector('.dropdown-overlay').classList.remove('out-of-sight');
    this.querySelector('#cartMenu').classList.remove('out-of-sight');
    this.querySelector('a.cart').classList.add('selected');
  }

  hideCartMenu() {
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('.dropdown-overlay').classList.add('out-of-sight');
    this.querySelector('#cartMenu').classList.add('out-of-sight');
    this.querySelector('a.cart').classList.remove('selected');
  }

  resetCartMenu() {
    if (!this.cartMenu.classList.contains('out-of-sight')) {
      this.hideCartMenu();
    }
  }

  setCartMenuHeight() {
    this.cartMenu.style.height = window.screen.availHeight;
  }

  loadCartItems() {
    var url = '/update';
    var data = { operation: '', sku: '', quantity: 0 };
    this.API.post(url, data)
      .then(data => {
        this.createItems(data);
      }).catch(error => {
      }).then(data => {
      })
  }

  toggleCartMenu() {
    if (this.cartMenu.classList.contains("out-of-sight")) {
      this.showCartMenu();
    } else {
      this.hideCartMenu();
    }
  }


  // Creates cart item components
  createItems(data) {
    this.checkoutUrl = data.checkoutUrl;
    this.total = data.total;
    this.discount = data.discount;
    this.formattedDiscount = data.formatted_discount;
    this.itemCount = data.count;
    let cartItems =
      data.items.map((item) =>
        `<cart-item 
        product='${JSON.stringify(item.product)}', 
        quantity="${item.quantity}", 
        price="${item.price}" 
        productcolor="${item.product.productcolor}" 
        sku="${item.product.sku}">
      </cart-item>`
      );
    const cartItemsParent = this.querySelector('.cart-items');
    cartItemsParent.innerHTML = cartItems.join('');
    // Update the product card status 
    let dataItems = data.items
      .filter(item => item.quantity >= 9)
      .map(item => (
        {
          'quantity': item.quantity,
          'sku': item.product.sku
        }
      ));
    this.dispatchEvent(new CustomEvent("cartUpdated", {
      detail: { 'sku': '', 'quantity': 0, 'offerText': data.offer_text }
      // detail: dataItems
    }));
    // Add handlers to respond to quantity picker change by updating cart order and cart component 
    var userCart = this;
    const items = this.querySelectorAll("cart-item")
    for (const item of items) {
      item.addEventListener('ItemRemoved', function (e) {
        userCart.removeProduct(e.detail.sku)
      });
      item.addEventListener('ItemQuantityChanged', function (e) {
        userCart.addToCart(e.detail.qty, e.detail.sku, 'change')
      });
    }
  }

  // Changes the quantity of the product in cart order
  addToCart(qty, sku, operation = 'add') {
    var url = '/update';
    var data = { operation: operation, sku: sku, quantity: qty };
    this.API.post(url, data)
      .then(data => {
        let dataItems = data.items.filter(item => item.product.sku == sku);
        if (dataItems.length > 0) {
          let cartItem = this.getCartItem(sku);
          if (cartItem !== undefined) {
            cartItem.quantity = dataItems[0].quantity;
            cartItem.price = dataItems[0].price;
          }
          else {
            this.addCartItem(dataItems[0]);
          }
          // Update the product card status 
          this.dispatchEvent(new CustomEvent("cartUpdated", {
            detail: { 'sku': sku, 'quantity': dataItems[0].quantity, 'offerText': data.offer_text }
          }));
          // Update cart summary
          this.total = data.total;
          this.discount = data.discount
          this.formattedDiscount = data.formatted_discount;
          this.itemCount = data.count;

          // send add_to_cart event to Google analytics.
          gtag("event", "add_to_cart", {
            currency: "INR",
            'send_to': 'G-S6C1WKTJNT',
            value: this.total,
            items: [
              {
                item_id: dataItems[0].sku,
                item_name: dataItems[0].product.name,
                currency: "INR",
                item_brand: "March",
                price: dataItems[0].price,
                quantity: dataItems[0].quantity,
                item_variant:dataItems[0].product.group,
                item_category:dataItems[0].product.type,
                item_category2:dataItems[0].product.type_name,
                item_category3:dataItems[0].product.style,
                item_category4:dataItems[0].product.variant,
              }
            ]
          });
        }

        // Reset the product cart add button text
        if (this.selectedProductCard) {
          setTimeout(() => {
            this.selectedProductCard.querySelector('a.button-add').innerHTML = 'ADD'
          }, 400)
        }
      }).catch(error => {
      }).then(data => {
      })
  }

  // Removes the product from the card order
  removeProduct(sku) {
    var url = '/update';
    var qty = 1;
    var data = { operation: 'remove', sku: sku, quantity: qty };
    this.API.post(url, data)
      .then(data => {
        let dataItems = data.items.filter(item => item.product.sku == sku);
        if (dataItems.length == 0) {
          this.removeCartItem(sku);
          // Update the product card status 
          this.dispatchEvent(new CustomEvent("cartUpdated", {
            detail: { 'sku': sku, 'quantity': 0, 'offerText': data.offer_text }
          }));
        }
        this.total = data.total;
        this.discount = data.discount;
        this.formattedDiscount = data.formatted_discount;
        this.itemCount = data.count;
      }).catch(error => {
      }).then(data => {
      })
  }

  // Creates a new cart item 
  addCartItem(item) {
    const cartItemsParent = this.querySelector('.cart-items');
    let cartItem = document.createElement('cart-item')
    cartItem.setAttribute('product', JSON.stringify(item.product))
    cartItem.setAttribute('quantity', item.quantity)
    cartItem.setAttribute('price', item.price)
    cartItem.setAttribute('background', item.product.background)
    cartItem.setAttribute('productcolor', item.product.productcolor)
    cartItem.setAttribute('sku', item.product.sku)
    cartItemsParent.appendChild(cartItem);

    // Add handlers to respond to cart item quantity picker change by updating cart order and cart component 
    let userCart = this;
    cartItem.addEventListener('ItemRemoved', function (e) {
      userCart.removeProduct(e.detail.sku)
    });
    cartItem.addEventListener('ItemQuantityChanged', function (e) {
      userCart.addToCart(e.detail.qty, e.detail.sku, 'change')
    });
  }

  // Removes a cart item when the quantity goes to zero
  removeCartItem(sku) {
    const cartItemsParent = this.querySelector('.cart-items');
    let cartItems = this.querySelectorAll('cart-item');
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].product.sku == sku) {
        let cartItem = cartItems[i]
        cartItem.quantity = 0
        cartItemsParent.removeChild(cartItem);
      }
    }
  }

  // Checks for a cart item by sku
  getCartItem(sku) {
    let cartItems = this.querySelectorAll('cart-item');
    var cartItem;
    for (var i = 0; i < cartItems.length; i++) {
      if (cartItems[i].product.sku == sku) {
        return cartItems[i];
      }
    }
    return cartItem;
  }

  // Calls the HTTP /cart/clear endpoint to 
  // delete the entire cart and order from the session. 
  // Returns a HTTP 302 redirect to the shop page.
  clear() {
    this.API.delete("/clear")
      .then((response) => {
        if (response.Status == 'Ok') {
          window.location.href = response.shopUrl;
        }
      })
      .catch()
  }
}
window.customElements.define('user-cart', UserCart);
